import { render, staticRenderFns } from "./VatPreviewBillGroup.vue?vue&type=template&id=286945c3&scoped=true"
import script from "./VatPreviewBillGroup.vue?vue&type=script&lang=js"
export * from "./VatPreviewBillGroup.vue?vue&type=script&lang=js"
import style0 from "./VatPreviewBillGroup.vue?vue&type=style&index=0&id=286945c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286945c3",
  null
  
)

export default component.exports